import React from "react";
import { useNavigate } from "react-router-dom";
import "./LegalLinks.css";

// `overVideo` : la barre est posée sur la vidéo de la home. Elle perd alors
// son bandeau blanc et laisse passer l'image. Le texte reste sombre, comme
// partout ailleurs. Piloté depuis App.js, qui seul sait quelle page est
// réellement affichée — le chemin "/" peut aussi rendre le compte à rebours.
export default function LegalLinks({ overVideo = false, darkText = false }) {
  const navigate = useNavigate();

  return (
    <div
      className={`legalGlobal${overVideo ? " legalGlobal--overVideo" : ""}${
        overVideo && darkText ? " legalGlobal--darkText" : ""
      }`}
    >
      <button className="legalGlobal__link" onClick={() => navigate("/terms")}>
        terms of service
      </button>
      <span className="legalGlobal__dot">·</span>
      <button className="legalGlobal__link" onClick={() => navigate("/legal")}>
        legal notice
      </button>
      <span className="legalGlobal__dot">·</span>
      <button className="legalGlobal__link" onClick={() => navigate("/privacy")}>
        privacy
      </button>
      <span className="legalGlobal__dot">·</span>
      <button className="legalGlobal__link" onClick={() => navigate("/refund")}>
        refund
      </button>
    </div>
  );
}
